import { useRef, useState } from 'react'
import { NotificationsOutlined as NotificationsIcon } from '@mui/icons-material'
import { Badge, IconButton, useMediaQuery, useTheme } from '@mui/material'
import { NotificationFeedPopover, useKnockFeed } from '@knocklabs/react'

import * as instrumentation from '../../../instrumentation'
import '@knocklabs/react/dist/index.css'

export default function Notifications() {
  const [isVisible, setIsVisible] = useState(false)
  const notifButtonRef = useRef(null)
  const { useFeedStore } = useKnockFeed()
  const feedStore = useFeedStore()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('md'))

  const notificationPipCount = feedStore.metadata.unread_count

  return (
    <>
      <IconButton
        aria-label="notifications"
        ref={notifButtonRef}
        onClick={() => {
          instrumentation.openedInAppNotifications()
          setIsVisible((current) => !current)
        }}
        size={isMobile ? 'small' : 'medium'}
      >
        <Badge
          badgeContent={notificationPipCount > 0 ? notificationPipCount : null}
          color="primary"
        >
          <NotificationsIcon sx={{ color: 'whitesmoke' }} />
        </Badge>
      </IconButton>
      <NotificationFeedPopover
        buttonRef={notifButtonRef}
        isVisible={isVisible}
        onClose={(e) => {
          // if someone clicks on the IconButton while the notification popover is open
          // then this event also fires, before the IconButton onClick event, which has
          // the effect of immediately re-opening the popover 🙃
          // stopPropogation fixes this by stopping the IconButton from receiving the click event.
          e.stopPropagation()
          setIsVisible(false)
        }}
        // don't use this one because a custom handler overwrites the default behaviour
        // the other two below seem to work fine with custom handlers
        // onNotificationButtonClick={}
        onNotificationClick={(item) => {
          instrumentation.clickedInAppNotification(item.id)
        }}
        onMarkAllAsReadClick={() => {
          instrumentation.clickedInAppNotificationMarkAllAsRead()
        }}
      />
    </>
  )
}
